import { render } from 'inferno';
import { Provider } from 'inferno-redux';
import { Router, Route, IndexRoute, Redirect } from 'inferno-router';
import createBrowserHistory from 'history/createBrowserHistory';
import configureStore from './store/configureStore';

import App from './App';
import IndexPage from './components/pages/IndexPage';

const browserHistory = createBrowserHistory();
const preloadedState = window.__PRELOADED_STATE__;
const store = configureStore(preloadedState);

render(
  <Provider store={ store }>
    <Router history={ browserHistory } >
      <Route path="/" component={ App } >
        <IndexRoute component={ IndexPage } />
        <Redirect from="*" to="/" />
      </Route>
    </Router>
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js